import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable()
export class ToastService {

  readonly DEFAULT_OPTIONS = {
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  };

  readonly MULTITOAST_OPTIONS = {
    duration: 2000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  };

  constructor(private readonly snackbar: MatSnackBar) { }

  toast(message: string, options?) {
    this.snackbar.open(message, '', options ?? this.DEFAULT_OPTIONS);
  }

  multiToast(messageList: Array<string>) {
    messageList.forEach( (message, index) => {
      setTimeout(() => {
        this.toast(message, this.MULTITOAST_OPTIONS);
      }, index * this.MULTITOAST_OPTIONS.duration);
    });
  }
}
